class Filter {
    constructor (element) {
        this.$filter = element;
        this.$filterCheckbox = this.$filter.querySelectorAll('[data-product-filter="checkbox"]');
        this.$filterCheckboxChecked = Array.from(this.$filterCheckbox).filter(checkbox => checkbox.checked).map(checkbox => checkbox.id);
        this.$filterCheckboxButton = this.$filter.querySelectorAll('[data-product-filter="button"]');
        this.$filterWrapper = this.$filter.querySelector('[data-product-filter="action"]');
        this.$filterSubmit = this.$filter.querySelector('[data-product-filter="submit"]');
        this.$filterClose = this.$filter.querySelector('[data-product-filter="close"]');
        this.$filterCategory = document.querySelectorAll('[data-product-filter="category"]');
        this.$filterAction = document.querySelector('[data-filter-action="action"]');
        this.$filterActionCount = document.querySelector('[data-filter-action="count"]');
        this.$filterTitle = this.$filter.querySelector('[data-product-filter="title"]');
        this.$filterLoader = document.querySelector('[data-product-overview="root"] .loader__item');
    }

    initialize () {
        this.setEvents();
    }

    // set events initial
    setEvents () {
        this.updateFilterCount();
        this.updateSubmitButton(this.$filterCheckboxChecked);
        this.scrollActiveItemIntoView();
        this.countHiddenFields();

        this.$filterCheckboxButton.forEach((button) => {
            button.addEventListener('click', (e) => {
                e.preventDefault();
                this.handleCheckboxChange(button);
            });

            button.addEventListener('change', () => {
                this.handleCheckboxChange(button);
            });

            button.addEventListener('keydown', (e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    this.handleCheckboxChange(button);
                }
            });
        });

        this.$filterCategory.forEach((category) => {
            category.addEventListener('click', () => {
                this.showSpinner();
            });
        });

        this.$filterCheckbox.forEach((checkbox) => {
            checkbox.addEventListener('change', () => {
                this.updateSubmitButton(this.$filterCheckboxChecked);
                this.updateFilterCount();
            });
        });

        this.$filterAction.addEventListener('click', () => {
            this.handleFilterOverlay();
        });

        this.$filter.addEventListener('keydown', (e) => {
            let isEnter = false;

            if ('key' in e) {
                isEnter = (e.key === 'Enter');
            } else {
                isEnter = (e.keyCode === 13);
            }

            if (isEnter) {
                const $element = e.target;

                if ($element.tagName.toLowerCase() === 'input' && $element.type === 'checkbox' && document.activeElement === $element) {
                    this.toggleInputChecked($element, !$element.checked);
                }
            }
        });
    }

    // shows/hide filter as overlay (mobile)
    handleFilterOverlay () {
        this.$filter.classList.add('filter--is-active');

        this.$filterClose.addEventListener('click', () => {
            this.$filter.classList.remove('filter--is-active');
        });
    }

    // show filter length (mobile)
    updateFilterCount () {
        const checkedCheckboxes = Array.from(this.$filterCheckbox).filter(checkbox => checkbox.checked);

        if (checkedCheckboxes.length > 0) {
            this.$filterActionCount.innerHTML = '(' + checkedCheckboxes.length + ')';
        } else {
            this.$filterActionCount.innerHTML = '';
        }
    }

    // is needed to show/hide filter options (mobile/desktop)
    handleCheckboxChange (label) {
        if (label.classList.contains('filter-label--is-active')) {
            label.classList.remove('filter-label--is-active');
            label.setAttribute('aria-expanded', 'false');
        } else {
            label.classList.add('filter-label--is-active');
            label.setAttribute('aria-expanded', 'true');
        }
    }

    // show/hide submit button (mobile/desktop)
    updateSubmitButton (initialCheckedCheckboxes) {
        const currentCheckedCheckboxes = JSON.stringify(Array.from(this.$filterCheckbox).filter(checkbox => checkbox.checked).map(checkbox => checkbox.id));
        if (JSON.stringify(initialCheckedCheckboxes) !== currentCheckedCheckboxes) {
            this.$filterSubmit.removeAttribute('disabled');
            this.$filterSubmit.classList.add('filter__submit-button--is-active');
            this.$filterWrapper.classList.add('filter__submit-action--is-active');
        } else {
            this.$filterSubmit.setAttribute('disabled', 'true');
            this.$filterSubmit.classList.remove('filter__submit-button--is-active');
            this.$filterWrapper.classList.remove('filter__submit-action--is-active');
        }
    }

    // scroll active category in view (mobile)
    scrollActiveItemIntoView () {
        let activeOffsetLeft = null;
        this.$filterCategory.forEach((item, index) => {
            if (item.classList.contains('filter__category--is-active')) {
                const container = item.parentElement;
                const containerPadding = container.currentStyle || window.getComputedStyle(container);

                activeOffsetLeft = item.offsetLeft;

                if (index === 0) {
                    container.scrollBy({
                        top: 0,
                        left: activeOffsetLeft - 16,
                        behavior: 'smooth'
                    });
                } else {
                    container.scrollBy({
                        top: 0,
                        left: activeOffsetLeft - parseInt(containerPadding.paddingLeft),
                        behavior: 'smooth'
                    });
                }
            }
        });
    }

    countHiddenFields () {
        if (this.$filterCheckboxButton.length < 1) {
            this.$filterTitle.style.display = 'none';
            this.$filterAction.style.display = 'none';
        }
    }

    toggleInputChecked ($input, state = true) {
        $input.checked = state;

        const toggleInputCheckedEvent = new CustomEvent('change', {
            view: window,
            bubbles: true,
            cancelable: false
        });

        $input.dispatchEvent(toggleInputCheckedEvent);
    }

    showSpinner () {
        if (this.$filterLoader) this.$filterLoader.hidden = false;

        window.addEventListener('pageshow', (event) => {
            if (event.persisted) {
                if (this.$filterLoader) this.$filterLoader.hidden = true;
            }
        });
    }
}

export { Filter };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $productFilter = $context.querySelectorAll('[data-product-filter="root"]');

        for (let i = 0; i < $productFilter.length; i++) {
            const productFilter = new Filter($productFilter[i]);
            productFilter.initialize();
        }
    }
});
